import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Meeting from "./pages/Meeting";
import Login from "./pages/Login";
import Policies from "./pages/Policies";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/meeting" element={<Meeting />} />
            <Route path="/login" element={<Login />} />
            <Route path="/policies" element={<Policies />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
